import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';

const cryptoStore = () => {
  const isLoading = ref<boolean>(false);
  const hasError = ref<boolean>(false);
  const cryptoList = ref<Crypto.Asset[]>([]);

  function $reset() {
    isLoading.value = false;
    cryptoList.value = [];
  }

  return {
    $reset,
    isLoading,
    hasError,
    cryptoList,
  };
};

export const useCryptoStore = defineStore('crypto', cryptoStore, storeConfig);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useCryptoStore, import.meta.hot));
}
